import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/dictionary_os";

const fetchListData = async () => {
  const { data = [] } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const dataWithId = data.map((record) => ({
    ...record,
    id: record.slug,
  }));

  return {
    data: dataWithId,
    total: data.length,
  };
};

export const osSchema: DataProviderSchema<"DictionaryOs", "json"> = {
  list: fetchListData,
};
